import { render } from "./FeedbackStars.vue?vue&type=template&id=4e032000&scoped=true&ts=true"
import script from "./FeedbackStars.vue?vue&type=script&lang=ts"
export * from "./FeedbackStars.vue?vue&type=script&lang=ts"

import _style_0 from "./FeedbackStars.vue?vue&type=style&index=0&id=4e032000&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-4e032000"]])

export default __exports__